import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { Action } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface ActionsParams extends DefaultHttpHeaders {
  /** Identifier code of policy */
  policyId: string;
  /** Identifier of the company who owns the final contract */
  companyId?: string;
}

@Injectable()
export class PolicyActionsService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Get policy's actions
   * Get policy's actions
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Policy/getPolicyActions
   */
  actions(params: ActionsParams): Observable<Action[]> {
    const pathParams = {
      policyId: params.policyId,
    };
    const queryParams = {
      companyId: params.companyId,
    };

    return this.get<Action[]>({
      suffix: `/home/policy/${pathParams.policyId}/actions`,
      queryParams,
      authenticationType: 'jwt',
    });
  }
}
